// Phase 9a · Admin autopay run + single-invoice retry + Stripe mode.
//
// Thin client for the FastAPI admin endpoints added in Phase 9a. All
// three are gated by admin JWT on the server side; this module just
// passes through the current Supabase session token.

import { supabase } from "@/lib/supabase";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

async function bearerToken() {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token || "";
}

export async function fetchStripeMode() {
  const token = await bearerToken();
  const resp = await fetch(`${API_BASE}/api/admin/stripe/mode`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!resp.ok) throw new Error(`Stripe mode check failed (${resp.status})`);
  return resp.json(); // { mode, via_emergent_proxy, key_prefix }
}

export async function runAdminAutopay({ dryRun }) {
  const token = await bearerToken();
  const url = `${API_BASE}/api/admin/autopay/run?dry_run=${dryRun ? "true" : "false"}`;
  const resp = await fetch(url, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!resp.ok) {
    const msg = await resp.text();
    throw new Error(msg || `Autopay run failed (${resp.status})`);
  }
  return resp.json();
}

export async function retryInvoiceAutopay(invoiceId) {
  const token = await bearerToken();
  const resp = await fetch(`${API_BASE}/api/admin/autopay/retry-invoice`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ invoice_id: invoiceId }),
  });
  if (!resp.ok) {
    const msg = await resp.text();
    throw new Error(msg || `Retry failed (${resp.status})`);
  }
  return resp.json();
}

export const STRIPE_MODE_META = {
  live:        { label: "Live mode",  tone: "border-[#C6851E]/40 bg-[#C6851E]/10 text-[#8A5A12]" },
  test:        { label: "Test mode",  tone: "border-amber-300 bg-amber-50 text-amber-900" },
  proxy_test:  { label: "Test mode",  tone: "border-amber-300 bg-amber-50 text-amber-900" },
  unconfigured:{ label: "Stripe off", tone: "border-neutral-200 bg-neutral-100 text-neutral-600" },
};
